import { ApolloClient, ApolloLink, ApolloProvider, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';
import { Auth } from 'aws-amplify';
import { AuthOptions, AUTH_TYPE, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { ErrorMessage } from 'src/enum/messsage-enum';

// GraphQL Setting
const APPSYNC_END_POINT = process.env.REACT_APP_APPSYNC_END_POINT as string;
const REGION = process.env.REACT_APP_REGION as string;
const IDENTITY_POOL_ID = process.env.REACT_APP_IDENTITY_POOL_ID as string;
const COGNITO_ID = process.env.REACT_APP_COGNITO_ID as string;

const AppApolloProvider = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  const linkConfig = {
    url: APPSYNC_END_POINT,
    region: REGION,
    auth: {
      type: AUTH_TYPE.AWS_IAM,
      credentials: fromCognitoIdentityPool({
        client: new CognitoIdentityClient({ region: REGION }),
        identityPoolId: IDENTITY_POOL_ID,
        logins: {
          [COGNITO_ID]: async () => {
            try {
              const currSession = await Auth.currentSession();
              return currSession.getIdToken().getJwtToken();
            } catch (err) {
              console.log(err);
              // stringを返す必要があるので適当な値を返す
              return 'errorjwt';
            }
          },
        },
      }),
    } as AuthOptions,
  };

  const httpLink = new HttpLink({ uri: APPSYNC_END_POINT });

  const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors)
      for (const err of graphQLErrors) {
        console.log(`[GraphQL error]: Message: ${err.message}, Location: ${err.locations}, Path: ${err.path}`);
        if (err.message === ErrorMessage.GRAPH_QL_TIME_OUT) return forward(operation);
      }

    if (networkError) console.log(`[Network error]: ${networkError}`);
  });

  const link = ApolloLink.from([
    errorLink,
    createAuthLink(linkConfig),
    createSubscriptionHandshakeLink(linkConfig, httpLink),
  ]);

  const client = new ApolloClient({ link, cache: new InMemoryCache() });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default AppApolloProvider;
